import { render, staticRenderFns } from "./DynamicContent.vue?vue&type=template&id=61bf395c"
import script from "./DynamicContent.vue?vue&type=script&lang=js"
export * from "./DynamicContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports